import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  background-color: ${props => props.color};
  height: 100%;
  transition: background-color 0.4s linear;
  .canvas {
    background-color: ${props => props.color};
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  
`;



// WEBPACK FOOTER //
// ./src/components/Loading/styles.js